import { computed, observable } from 'mobx';
import { autobind } from 'core-decorators';
import { noop } from '@src/utils/common-util';
import langLocalesData from '@src/business-components/common-footer/langconfig.json';
import { COOKIE_FLAG } from '@src/business-components/common-footer/components/cookie-tips/store';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
const lang = getLanguageByPath();
const cookieInfo = langLocalesData[lang]?.cookieInfo;

class CookieSettingModalStore {
  onClose = noop;

  rejectOptionalCookies = noop;

  acceptOptionalCookies = noop;

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  /**
   * 是否显示
   * @type {boolean}
   */
  @observable isShow = false;
  /**
   * 是否允许cookies
   * @type {{analytics: boolean, necessary: boolean}}
   */
  @observable
  acceptCookies = {
    necessary: true,
    analytics: false
  };
  /**
   * 数据分析的cookie列表
   * @type {[]}
   */
  @observable
  analyseCookiesList = [
    {
      name: '_ga',
      provider: 'Google Analytics',
      duration: cookieInfo._ga_duration,
      description: cookieInfo._ga_description
    },
    {
      name: '_ga_XXXXXXXXXX',
      provider: 'Google Analytics',
      duration: cookieInfo._ga_x_duration,
      description: cookieInfo._ga_x_description
    },
    {
      name: '_gid',
      provider: 'Google Analytics',
      duration: cookieInfo._gid_duration,
      description: cookieInfo._ga_x_description
    }
  ];
  /**
   * 必要的cookies列表
   * @type {[]}
   */
  @observable
  necessaryCookiesList = [
    {
      name: COOKIE_FLAG,
      provider: 'Seasun Games',
      duration: cookieInfo.cookie_flag_duration,
      description: cookieInfo.cookie_flag_description
    },
    {
      name: 'session_id',
      provider: 'Seasun Games',
      duration: cookieInfo.session_id_duration,
      description: cookieInfo.session_id_description
    },
    {
      name: 'session_id_',
      provider: 'Seasun Games',
      duration: cookieInfo.session_id_duration,
      description: cookieInfo.session_id_description
    }
  ];

  /**
   *
   * @type {number}
   */
  @observable pageIndex = 0;

  @computed
  get isPreferenceSetting() {
    return this.pageIndex === 0;
  }

  /**
   * 是否为necessaryCookies页面
   * @returns {boolean}
   */
  get isNecessaryCookies() {
    return this.pageIndex === 1;
  }

  /**
   * 是否为AnalyticsCookies页面
   * @returns {boolean}
   */
  get isAnalyticsCookies() {
    return this.pageIndex === 2;
  }

  @autobind
  backToIndex() {
    this.pageIndex = 0;
  }

  @autobind
  redirectToPage(index) {
    this.pageIndex = index;
  }

  /**
   * 修改是否接受cookie的状态
   */
  @autobind
  onChangeAcceptCookieStatus(type) {
    this.acceptCookies[type] = !this.acceptCookies[type];
  }

  /**
   * 接受所有的cookie
   */
  @autobind
  acceptAllCookie() {
    // this.acceptCookies.necessary = true;
    this.acceptCookies.analytics = true;
    this.acceptOptionalCookies();
  }

  /**
   * 拒绝所有的cookie
   */
  @autobind
  rejectAllCookie() {
    this.acceptCookies.analytics = false;
    this.rejectOptionalCookies();
  }

  /**
   * 点击"确定"时回调
   */
  @autobind
  onConfirmCookieOptionsClick() {
    if (this.acceptCookies.analytics) {
      this.acceptOptionalCookies();
    } else {
      this.rejectOptionalCookies();
    }
  }

  use() { }
}

export default CookieSettingModalStore;
